/**
 * Site-wide PostHog `add_to_cart` event.
 *
 * Fires once for every successful add from any product-form on any page:
 * the main product button, the sticky mobile bar, card quick add, the
 * quick-add modal and the featured product section. `atc_button` says which
 * one (set by ProductForm.getAtcButton in assets/product-form.js), so the
 * sticky-mobile-atc test can still filter on atc_button = 'sticky'.
 *
 * Cart drawer quantity changes and removals (source 'cart-items') are not
 * adds and are ignored.
 */
(function () {
  'use strict';

  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined' || !PUB_SUB_EVENTS.cartUpdate) {
    return;
  }

  subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
    if (!event || event.source !== 'product-form') return;
    if (!window.posthog || typeof window.posthog.capture !== 'function') return;

    var item = event.cartData || {};

    window.posthog.capture('add_to_cart', {
      atc_button: event.atcButton || 'unknown',
      purchase_type: event.purchaseType,
      product_id: item.product_id,
      variant_id: item.variant_id || event.productVariantId,
      product_title: item.title,
      price: item.price,
      quantity: item.quantity,
      source: event.source,
      page_path: window.location.pathname,
    });
  });
})();
